var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90348 7.03335L12.9369 2.06434C13.1991 1.806 13.2045 1.38602 12.949 1.12768C12.6935 0.868898 12.2744 0.868898 12.0123 1.12768L6.97885 6.09669L2.07363 1.12768C1.81816 0.868898 1.39905 0.868898 1.13691 1.12768C0.874775 1.38602 0.869357 1.806 1.12482 2.06434L6.03005 7.03335L0.99661 12.0024C0.734476 12.2607 0.729058 12.6807 0.984526 12.939C1.11226 13.0684 1.28101 13.1329 1.4506 13.1329C1.62019 13.1329 1.79017 13.0684 1.92124 12.939L6.95468 7.97L11.8599 12.939C11.9876 13.0684 12.1564 13.1329 12.326 13.1329C12.4956 13.1329 12.6656 13.0684 12.7966 12.939C13.0588 12.6807 13.0642 12.2607 12.8087 12.0024L7.90348 7.03335",
    strokeWidth: 1.39772
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6ceda8062021ca986e976f8d9a4f5934.svg";
export { ForwardRef as ReactComponent };